import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditMasterModel = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###",defaultMessage:"Edit Master Model" }));
  const history = useHistory();
  const [modelGroup, setModelGroup] = useState();
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState(0)
  const [state, setState] = useState(true);

  const AlertError = (message) => {
    Swal.fire("Master Model!", message, "error");
  };

  useEffect(() => {
    setModelGroup(props.location.state.row.modelGroup);
    setName(props.location.state.row.name);

  }, []);

  const onSubmit = async (state) => {
    if (modelGroup === undefined || modelGroup === "") {
      return AlertError("please insert model group.");
    }

    if (name === undefined || name === "") {
      return AlertError("please insert model name.");
    } 
      
    var events = {
      name,
      modelGroup,
      enabled: state,
      display_order: displayOrder === 0 ? 0 : displayOrder,
    };

    let apiUrls = `${baseURLV1}/dynamic/masterModels/${props.location.state.row.id}`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "put",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Edit !",
          "Your can not update group. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Edit Master Model "></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Model Name" })}:{" "}
            </p>
            <input
              name="name"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>
                *
            </span>
              {intl.formatMessage({ id: "###",defaultMessage:"Model Group" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={modelGroup}
              onChange={(e) => setModelGroup(e.target.value)}
            />
          </div>

  
          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/MasterModel">
              <button type="button" className="btn btn-secondary wbt mr-5">
              {intl.formatMessage({ id: "###",defaultMessage:"Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
            {intl.formatMessage({ id: "###",defaultMessage:"Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
